import {  Component,OnDestroy, OnInit } from '@angular/core';
import { ProcesoReporte } from 'src/app/pages/base/proceso-reporte';
import { AppComponent } from 'src/app/app.component';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { FormBuilder } from '@angular/forms';
import { IHeader, Pdf } from 'src/app/clases/pdf';
import { XlsxService } from 'src/app/services/utils/xlsx.service';
import { EstadoCuentaService } from 'src/app/services/asociaciones/estado-cuenta.service';

@Component({
  selector: 'app-estado-cuenta',
  templateUrl: './estado-cuenta.component.html',
  styleUrls: ['./estado-cuenta.component.scss']
})
export class EstadoCuentaComponent  extends ProcesoReporte implements OnInit {
  grafico !: Highcharts.Chart | undefined | any;
  mostrarGrafico : boolean = false;
  pantallaCompletaGrafico : boolean = false;
  agrupaciones : Record< string, any >[] = []; 
  totalLimiteCredito = 0;
  totalSaldoCapital = 0;
  totalSaldoLimite = 0;

  constructor(
    public app: AppComponent, 
    private breadcrumbService: AppBreadcrumbService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private xlsxService : XlsxService,
    private service: EstadoCuentaService,
  ) {
    super();
    this.crearFormulario();
    this.breadcrumbService.setItems([ { label: 'Gestion de Cobros' } ]);
  }

  ngOnInit(): void {
    setTimeout( async () => {
      await this.traerAgrupaciones();
    }, 200)
  }

  async crearFormulario() {
    const hoy = new Date();
    
    this.formGroup = this.fb.group({
      agrupaciones: [[]],
    });
  }

  async traerAgrupaciones() {
    try{
      const resp = await this.service.getAgrupaciones();
      this.agrupaciones = resp.resp;
      for ( const agrupacion of resp.resp ){
        const agrupaciones =  [ ...this.formGroup.get('agrupaciones').value ]
        agrupaciones.push( agrupacion.cod_agrupacion )
        this.formGroup.get('agrupaciones').setValue( agrupaciones )
      }
    } catch( error ){
      this.agrupaciones = [];
      this.messageService.add({severity: 'error', 'summary': 'Ocurrio un error al traer las agrupaciones'});
      console.error( 'Error al traer las agrupaciones ', error )
    }
  }

  async ejecutar(){
    this.items = [];
    this.totalLimiteCredito = 0;
    this.totalSaldoCapital = 0;
    this.totalSaldoLimite = 0;

    const value = this.formGroup.getRawValue();
    try {    
        this.loading = true;
        this.items = [];
        const resp = await this.service.getEstadoCuenta( value );
        if( resp.ok === true ){
          if( resp.resp.length < 1 ){
            this.messageService.add({severity: 'info', 'summary': 'No existen datos sobre las cuentas' })
            this.loading = false;
            return;
          }
          this.items = resp.resp;
          for( const agrupacion of this.items ) {
            this.totalLimiteCredito += agrupacion.limite_credito;
            this.totalSaldoCapital += Number( agrupacion.saldo_capital );
            this.totalSaldoLimite += agrupacion.saldo_limite;
          }
        }
        
        this.loading = false;
    } catch (error: any) {
        this.messageService.add({severity: 'error', 'summary': 'Ocurrio un error al traer los cobros'})
        console.error( error )
        this.loading = false;
    }
  }
  
  traducirCondicion( condicion: boolean ) : string {
    return condicion ? 'Si' : 'No';
  }

  async descargar() {
      const pdf = new Pdf(this.currentUser);
      pdf.title =  `Estados de cuenta`;
              pdf.headers = [
            { label: 'Cod. Agrupacion', name: 'cod_agrupacion', type: 'number' },
            { label: 'Agrupacion', name: 'des_agrupacion', type: 'text' },
            { label: 'Limite de credito', name: 'limite_credito', type: 'number' },
            { label: 'Saldo capital', name: 'saldo_capital', type: 'number' },
            { label: 'Saldo Limite', name: 'saldo_limite', type: 'number' },
        ]
        for (const item of this.items) {
            pdf.addSource({ 
                data: item,
            });
        }
        const totales = {
          totalLimiteCredito : this.totalLimiteCredito,
          totalSaldoCapital : this.totalSaldoCapital,
          totalSaldoLimite : this.totalSaldoLimite,
        } 
        pdf.foot = {
            headers: [
                { label: 'Total limite de credito', name: 'totalLimiteCredito', type: 'number' },
                { label: 'Total saldo capital', name: 'totalSaldoCapital', type: 'number' },
                { label: 'Total saldo limite', name: 'totalSaldoLimite', type: 'number' },
            ],
            source: totales,
        }

        pdf.exportar();
  }
  async descargarExcel() {
      const datos: Record<string, any>[] = [];
      const value = this.formGroup.getRawValue();
      for (const item of this.items) {
        datos.push({
          'Cod. Agrupacion': item.cod_agrupacion,
          'Agrupacion': item.des_agrupacion,
          'Limite de credito': item.limite_credito,
          'Saldo Capital': item.saldo_capital,
          'Saldo Limite': item.saldo_limite,
        })
      }
      await this.xlsxService.exportAsExcelFile(datos,'reporte_estado_cuenta');
  }

}
